/**
 * @fileoverview Module for `src/dashboard/manage-letters/LetterFilter.js`.
 */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

LetterFilter.propTypes = {
  className: PropTypes.string,
  letterFilter: PropTypes.string,
  updateFilter: PropTypes.func,
};


/**
 * Controls free-text filtering for manage letters bundle queries.
 *
 * @param {Object} params
 * @returns {JSX.Element} Search input with clear action.
 */
export default function LetterFilter({
  className,
  letterFilter,
  updateFilter,
}) {
  const [currentFilter, setCurrentFilter] = useState(letterFilter);
  useEffect(() => {
    setCurrentFilter(letterFilter);
  }, [letterFilter]);

  /**
   * Updates local input state as the user types.
   *
   * @param {Event} event
   * @returns {void}
   */
  const onFilterChange = (event) => {
    setCurrentFilter(event.target.value);
  };

  /**
   * Blurs the input on Enter so the current filter is submitted.
   *
   * @param {KeyboardEvent} event
   * @returns {void}
   */
  const blurOnEnter = (event) => {
    if (event.key === 'Enter') {
      event.target.blur();
    }
  };

  /**
   * Applies the current local filter value to parent query state.
   *
   * @returns {void}
   */
  const submitFilter = () => {
    updateFilter(currentFilter);
  };

  return (
    <div className={ className }>
      <div className='row'>
        <input
          aria-label='Filter letters'
          className='col input-col'
          id='filterInput'
          onBlur={ submitFilter }
          onChange={ onFilterChange }
          onKeyDown={ blurOnEnter }
          onSubmit={ (e) => e.preventDefault() }
          placeholder='Search for a voter, campaign, or bundle ID'
          type='text'
          value={ currentFilter }
        />
        <i className='fa fa-search col decoration-col' />
        <button className='btn-bundle-status btn-secondary-v2 clear-filter rounded-pill col decoration-col' onClick={ () => updateFilter('') } type='button'>
          <i className='fa fa-times' /> Clear filter
        </button>
      </div>
    </div>
  );
}
